// src/components/Home/Partners.tsx
import React from 'react';
import { motion } from 'framer-motion';

const Partners: React.FC = () => {
  const partners = [
    { name: "Green the Future Program", logo: "/images/partner-1.png" },
    { name: "Government of Kenya", logo: "/images/partner-2.png" },
    { name: "County Government of West Pokot", logo: "/images/partner-3.jpg" },
    { name: "UNEP", logo: "/images/partner-4.png" },
    { name: "Action Against Hunger", logo: "/images/partner-5.svg" },
    { name: "World Vision Kenya", logo: "/images/partner-6.webp" }
  ];

  return (
    <section className="py-5 bg-light">
      <div className="container">
        <div className="row text-center mb-5">
          <div className="col-12">
            <motion.h2 
              className="display-5 fw-bold text-success mb-3"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              Our Trusted Partners
            </motion.h2>
            <motion.p 
              className="lead text-muted"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              Collaborating with organizations that share our vision for sustainable development
            </motion.p>
          </div>
        </div>

        <motion.div 
          className="row align-items-center justify-content-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
        >
          {partners.map((partner, index) => (
            <div key={index} className="col-6 col-md-4 col-lg-2 mb-4">
              <div className="card border-0 bg-white shadow-sm h-100 text-center">
                <div className="card-body p-3">
                  <img 
                    src={partner.logo} 
                    alt={partner.name}
                    style={{ 
                      maxHeight: '60px', 
                      maxWidth: '100px', 
                      objectFit: 'contain'
                    }}
                    onError={(e) => {
                      // Fallback to colored box with first letter if image fails
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      target.parentElement!.innerHTML = `
                        <div class="bg-success text-white rounded d-flex align-items-center justify-content-center mx-auto mb-2" 
                             style="width: 80px; height: 60px; font-size: 1.5rem; font-weight: bold">
                          ${partner.name.charAt(0)}
                        </div>
                        <small class="text-muted d-block">${partner.name}</small>
                      `;
                    }}
                  />
                  <small className="text-muted d-block mt-2">{partner.name}</small>
                </div>
              </div>
            </div>
          ))}
        </motion.div>

        {/* Partner With Us Section */}
        <motion.div 
          className="row mt-5"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="col-12 text-center">
            <div className="bg-success text-white rounded p-4">
              <h5 className="fw-bold mb-3">Become a Partner</h5>
              <p className="mb-3 opacity-75">
                Join us in creating sustainable impact across African communities
              </p>
              <a href="/contact" className="btn btn-light btn-sm">
                Partner With Us
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Partners;